import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class PageViewApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.PageView;

  getPayload(): any {
    return {
    };
  }
}
